import { LinkContainer } from "react-router-bootstrap";
import { Table, Button } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import { useGetOrdersQuery } from "../../slices/ordersApiSlice";

const OrderListScreen = () => {
  const { data: orders, isLoading, error } = useGetOrdersQuery();

  return (
    <>
      <h1 className="text-end">הזמנות</h1>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <Table striped bordered hover responsive className="table-sm">
          <thead>
            <tr>
              <th></th>
              <th>נשלח</th>
              <th>שולם</th>
              <th>סה"כ</th>
              <th>תאריך</th>
              <th>לקוח</th>
              <th>מספר הזמנה</th>
            </tr>
          </thead>
          <tbody>
            {[...orders].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((order) => (
              <tr key={order._id}>
                <td>
                  <LinkContainer to={`/order/${order._id}`}>
                    <Button variant="light" className="btn-sm">
                      פרטים
                    </Button>
                  </LinkContainer>
                </td>
                <td>
                  {order.isDelivered ? (
                    order.deliveredAt.substring(0, 10)
                  ) : (
                    <FaTimes style={{ color: "red" }} />
                  )}
                </td>
                <td>
                  {order.isPaid ? (
                    order.paidAt.substring(0, 10)
                  ) : (
                    <FaTimes style={{ color: "red" }} />
                  )}
                </td>
                <td>₪{order.totalPrice}</td>
                <td>{order.createdAt.substring(0, 10)}</td>
                <td>{order.user && order.user.name}</td>
                <td>{order._id}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default OrderListScreen;
